<div class="flex flex-col flex-auto min-w-0">
  <div
    class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-transparent"
  >
    <div class="flex-1 min-w-0">
      <div></div>
      <div class="mt-2">
        <h2
          class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate"
        >
          Admin Membership Form
        </h2>
      </div>
    </div>
  </div>
  <div class="flex-auto p-6 sm:p-10">
    <div class="">
      <form
        class="p-4 bg-card shadow rounded overflow-hidden"
        [formGroup]="adminForm"
        #adminFormNgForm="ngForm"
        (ngSubmit)="onFormSubmit()"
      >
        <div class="flex flex-col gt-xs:flex-row">
          <div class="mainDiv">
            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Administrator Name</mat-label>
              <input
                [placeholder]="'Administrator Name'"
                id="name"
                matInput
                [formControlName]="'name'"
                required
              />
              <mat-error *ngIf="adminForm.get('name').hasError('required')"
                >Please enter administrator name</mat-error
              >
            </mat-form-field>

            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Email</mat-label>
              <input
                [placeholder]="'Email'"
                id="email"
                matInput
                [formControlName]="'email'"
                type="email"
                readonly
                required
              />
              <mat-error *ngIf="adminForm.get('email').hasError('required')"
                >Please enter email</mat-error
              >
              <mat-error *ngIf="adminForm.get('email').hasError('email')"
                >Please enter a valid email</mat-error
              >
            </mat-form-field>
          </div>

          <div class="mainDiv">
            <!-- <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Address</mat-label>
              <input
                [placeholder]="'Address'"
                id="address"
                matInput
                [formControlName]="'address'"
              />
              <mat-error>Please enter address</mat-error>
            </mat-form-field> -->

            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Phone</mat-label>
              <input
                [placeholder]="'Phone'"
                id="phone"
                matInput
                [formControlName]="'cellPhone'"
                (input)="onInputNumeric($event)"
                required
              />
              <mat-error>Please enter phone number</mat-error>
            </mat-form-field>

            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>City</mat-label>
              <input
                [placeholder]="'City'"
                id="city"
                matInput
                [formControlName]="'city'"
              />
              <mat-error>Please enter city</mat-error>
            </mat-form-field>
          </div>

          <div class="mainDiv">
            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Role</mat-label>
              <mat-select formControlName="role" required>
                <mat-option [value]="'Admin'"> Administrator </mat-option>
              </mat-select>
              <mat-error>Please select a role</mat-error>
            </mat-form-field>
          </div>

          <div class="mainDiv"></div>
        </div>

        <div class="text-center mt-8">
          <button
            class="px-8 ml-4 submit-button"
            mat-raised-button
            color="primary"
            [disabled]="adminForm.invalid"
            aria-label="AddAdministrator"
          >
            Add
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="loaderMain" *ngIf="pageLoader === true">
    <div>
      <img src="assets\TrailFusion\Trail-Fusion-logo.jpg" class="LoaderImage" />
      <p class="loaderText">{{ pageLoaderText }}</p>
    </div>
  </div>
</div>
